import PropTypes from 'prop-types';
import ServiceType from './components/ServiceType';

const ServiceTypes = ({
  iconColor = 'purple',
  serviceTypes = [],
}) => (
  <ul
    className='text-sm max-w-9/10'
    // replace when we upgrade tailwind
    style={{
      columns: '280px 3',
    }}
  >
    {
      serviceTypes.map(st => (
        <ServiceType
          iconColor={iconColor}
          key={`service-type-${st.code}`}
          level={0}
          serviceType={st}
          showIcon
        />
      ))
    }
  </ul>
);

ServiceTypes.propTypes = {
  /** color of ServiceType icons */
  iconColor: PropTypes.string,
  /** array of serviceType objects */
  serviceTypes: PropTypes.array.isRequired,
};

export default ServiceTypes;
